export default {

    //General phrases
    tollWord: ' Opłata za most Fetesti | Opłaty za most Fetesti | przejście',
    vignetteWord: 'Rowinieta | Rowiniety',

    site_tpf: 'taxa-pod-fetesti.ro',
    site_erv: 'e-rovinieta.ro',

    currency: 'lei',
    category: 'kategoria',
    select_type_of_vehicle: `Wybierz typ pojazdu`,
    select_the_period: 'Select the period',
    or_pay_for: 'Albo zapłacić za',
    your_vehicles_link: 'Swoje pojazdy',
    or_go_to_your_account_and_buy: 'Lub zaloguj się na Swoje konto i kup bezpośrednio dla swoich samochodów',
    see_cart: 'Zobacz koszyk',
    or: 'lub',
    and: 'i',
    back: 'powrót ',
    total: 'Razem',
    pf: 'Osoba fizyczna',
    pj: 'Osoba prawna',
    yes: 'Tak',
    no: 'Nie',
    about: 'O',
    us: 'My',

    vignette: 'ROwinieta | ROwiniety',
    passing: 'przejazd | przejazdy',

    toll_buy: ' Zapłać opłatę za most ',
    vignette_buy: ' Zapłać ROwinieta',

    //Order
    billing_add_new_profile: ' dodaj nowy profil rozliczeniowy ',

    cart_empty: ' Kosz pusty ',
    cart_available_from: ' ważny od ',
    cart_add_more: ' Dodawaj kolejne do koszyka ',
    cart_continue_with_buying: ' Kup więcej ',
    cart_validation_errors: ' Produkty usunięte z zamówienia z powodu błędów weryfikacji ',

    order_container_place_order_title: ' Złóż zamówienie ',
    order_container_my_cart: ' Mój koszyk ',
    order_container_billing_info: ' dane rozliczeniowe ',
    order_container_payment: ' Płatność ',

    payment_method_insuficient_credit: 'Niewystarczający kredyt ',
    payment_method_instant_credit: 'natychmiastowy kredyt',
    payment_method_instant_credit_description: 'natychmiastowy kredyt ',
    payment_method_credit_card: 'Online za pomocą karty bankowej ',
    payment_method_credit_card_description: 'Płatność zostanie przetworzona w PayU.ro',
    payment_method_iTransfer_description: 'Polecenie zapłaty z natychmiastowym potwierdzeniem',
    payment_method_payment_order: 'Polecenie zapłaty ',
    payment_method_payment_order_description: ' Otrzymasz e-mailem proformę związaną z zakupem, zawierającą instrukcje dotyczące płatności. Zamówienie zostanie wydane po otrzymaniu płatności',
    payment_method_credit_erv: 'Kredyt e-rovinieta',
    payment_method_credit_tpf: 'Kredyt opłata most Fetesti',
    payment_method_terms: ' Potwierdzam, że powyższe dane są prawidłowe oraz że zapoznałem się i zgadzam się z regulaminem ',

    thank_you_placed_order_title: ' Zamówienie złożone ',
    thank_you_successful_order: ' Zamówienie zostało złożone pomyślnie!',
    thank_you_see_info_order: ' Zobacz jej status w moich zamówieniach ',
    thank_you_my_orders: 'Comenzile mele',

    //Account
    continue_with: 'Continue with',
    account_activate_header: ' Aktywuj konto ',
    account_activate_message: '',

    account_container_my_account: ' Moje konto ',
    account_container_vehicles: ' Pojazdy ',
    account_container_orders: 'Zamówienia',
    account_container_profiles: ' Profile rozliczeniowe ',
    account_container_info: ' Dane konta',

    account_data_title: ' Szczegóły konta ',

    add_car_title: ' Dodaj pojazd ',

    add_profile_title: ' Dodaj profil ',
    add_profile_pj_extracted: 'Dane podmiotu prawnego pobrane automatycznie',

    edit_car_no_vehicles: ' Nie znaleziono pojazdów! ',
    edit_car_delete_vehicle_title: ' Usuń pojazd',
    edit_car_delete_vehicle: ' Czy na pewno chcesz usunąć ten pojazd? ',

    my_orders_passings: 'przejazd | {count} przejazdy ',

    profiles_main: 'Główny',
    profiles_secondary: 'Wtórny',
    profiles_unverified_data: 'Niezweryfikowane daty',
    profiles_no_profile: ' Brak profilu ',
    profiles_delete_profile: 'Usuń profil ',
    profiles_are_you_sure: 'Czy na pewno chcesz usunąć ten profil?',

    //Authentication
    login_auth: ' Zaloguj sie ',
    login_login_into_your_account: 'Zaloguj się na swoje konto',

    login_component_login_by: ' Zaloguj się z ',
    login_component_no_account: ' Nie masz konta? ',
    login_component_forgot_password: 'Zapomniałeś hasła?',

    new_account_title: ' Nowe konto ',
    new_account_details: ' Szczegóły Konta',
    new_account_ive_read: ' Przeczytałem i zgadzam się ',
    new_account_tc: ' Zasadami i warunkami ',
    new_account_site: 'stronie internetowe',
    new_account_pc: ' Polityka prywatności ',
    mandatory: 'Obowiązkowy',
    new_account_must_accept_tc: 'Musisz zaakceptować warunki',
    new_account_must_accept_pc: 'Musisz zaakceptować politykę prywatności',

    contact_title: 'Kontakt',

    header_how_does_it_work: 'Jak to działa?',

    how_it_works_p1: 'Jesteś w drodze za 3 minuty!',
    how_it_works_p2: 'Autoryzowany dystrybuto CNAIR',
    how_it_works_p3: 'Zamów online za pomoc taxa-pod-fetesti.ro',

    toll_category_error_loading_car: ' Problem z załadowaniem samochodu',
    toll_category_error_loading_country: 'Problem załadunku krajów',

    vignette_category_error_fromdate: 'Wybierz datę, kiedy rowinieta wejdzie w życie',

    //Buttons
    btn_save: 'Zapisać',
    btn_save_changes: 'Zapisz zmiany',
    btn_add_car: 'Dodaj pojazd',
    btn_delete_car: 'Usuń pojazd',
    btn_next_step: 'Następny krok',
    btn_finish: 'Zakończyć',
    btn_grab_data_company: 'Odzyskaj dane <br/> Rejestr handlowy',
    btn_add_profile: ' Dodaj nowy profi ',
    btn_i_understand: ' rozumiałem ',
    btn_login: 'Zaloguj sie',
    btn_register: ' Zarejestruj się ',
    btn_create_account: ' Utwórz konto ',
    btn_add_to_cart: ' Dodaj do koszyka ',
    btn_edit_to_cart: 'Zmodyfikuj produkt',
    btn_reset_password: 'Zresetuj hasło',
    btn_bill: 'Factureaza',
    btn_choose_payment_method: 'Choose payment method',


    //Labels
    label_email: 'Email',
    label_password: 'Hasło',
    label_confirm_password: 'Potwierdź swoje hasło',
    label_license_plate: 'Numer rejestracyjny',
    label_chasis_number: 'Seria podwozia',
    label_registration_country: 'Kraj rejestracji',
    label_motif: ' Powód niższej kategorii ',
    label_choose_category: ' Wybierz kategorię dla ',
    label_billing_type: ' Rozliczenie w ',
    label_last_name: ' Imię ',
    label_first_name: ' Nazwisko',
    label_country: 'Kraj',
    label_county: ' Województwo ',
    label_city: ' Miasto ',
    label_address: 'Adres',
    label_cui: 'NIP',
    label_reg_com: 'Rejestr handlowy',
    label_locality: 'miejscowość',
    label_company_name: 'Nazwa firmy',
    label_for_car: 'Dla pojazdu',
    label_available_from: ' Ważne od daty ',

    //terms
    terms: 'Regulamin',
    partners: 'partner',

    delete_product_title: 'Delete product',
    delete_product: 'Are you sure you want to delete this product?',

    //New terms
    btn_edit: 'Zmień',
    btn_edit_password: ' Zmień hasło',
    btn_edit_phone: ' Zmień numer telefonu',
    btn_delete_account: 'Usuń konto',
    btn_import_csv: 'Importuj csv',
    btn_export_csv: 'Eksportuj  csv',

    //account
    data_saved_succesfully: 'Dane zapisane z powodzeniem',
    invalid_plate_number_message: 'Numer w niewłaściwym formacie ',
    invalid: 'Nieważny ',
    countries_loading: 'Problem z ładowaniem krajow ',
    tpf_categories_loading: 'Problem z ładowaniem kategorii opłat drogowych fetesti',
    erv_categories_loading: 'Problem z ładowaniem kategorii  rowiniet',
    csv_header: 'Numer, Podwozie, Kategoria rowiniety, Kategorie opłaty za most w Feteşti, Kraj',
    order_header_name: 'Nazwa',
    date: 'Data',
    order_header_payment_type: 'Rodzaj płatności',
    order_header_status: 'Status',
    no_placed_order: 'Nie ma żadnego złożonego zamówienia.',
    i_want: 'Chcę',
    no_order: 'Zamówienia nie można było znaleźć.',

    product_status: 'Status',
    product_payment_method: 'Sposób płatności',
    product_bill_data: 'Dane do faktury',
    product_valability: 'Ważność',

    download_bill: 'Pobierz  fakturę',
    vignette_series: 'Serie rowiniety',
    toll_series: 'Serie peaj',

    //authentication
    login_account: 'Wejdź do konta',
    already_have_account: 'Czy masz już konto?',
    password: 'Hasło',
    password_confirm: 'Powtórz hasło',
    return_to_login_1: ' Wróć do strony ',
    return_to_login_2: 'Login',

    // order
    choose_profile: 'Wybierz  profil',
    order_step4: 'Krok  4: Fakturowanie',
    login_to_your_account: 'Wejdź do swojego konta',
    login_to_your_account_2: 'I wybierz już zapisane dane do fakturowania .',
    order_without_account: 'Zamówienie można składać bez konta, wypełniając poniższymi danami',
    fill_all_fields: 'Wypełnij wszystkie obowiązkowe pola',
    order_address_info: 'Pod tym adresem dostaniesz  fakturę i rowinietę',
    invalid_profile_msg: 'Ten profil jest nieważny ',
    delete_profile_msg: 'Usuń profil',
    delete_profile_confirm: 'Czy na pewno chcesz usunąć profil ?',
    invalid_email: ' Nieważny adres e-mailowy ',
    invalid_tel: ' Nieważnu numer telefonu',
    mandatory_city: 'Podanie miasta jest obowiązkowe',
    mandatory_first_name: 'Podanie imienia/imion  jest obowiązkowe',
    mandatory_last_name: 'Podanie nazwiska jest obowiązkowe',
    mandatory_country: 'Podanie województwa  jest obowiązkowe',
    mandatory_fiscal_code: ' Podanie NIP jest obowiązkowe',
    mandatory_j_code: ' Podanie numeru w Rejestrze Handlowym jest obowiązkowe',
    mandatory_company: 'Podanie firmy jest obowiązkowe ',
    mandatory_address: ' Podanie adresu jest obowiązkowe',
    my_shopping_cart: 'Mój koszyk',
    order_step3: 'Krok 3: Streszczenie',
    buy_vignette_or_bridge_fee: 'Możesz kupić rowinietę lub opłatę za most w Fetești',
    order_step5: 'Krok 5: Płatność',
    warning: 'UWAGA!',
    warning_txt_1: 'W przypadku płatności za rowiniety  poleceniem płatności, zamówienie zostanie zatwierdzone po zaksięgowaniu pieniędzy na rachunku bankowym UNTRR.',
    warning_txt_2: 'Rowiniety opłacone poleceniem płatności są  wydawane od poniedziałku do piątku w godzinach 08:00 - 16:30',
    warning_txt_3: 'Nie ruszajcie w drogę, dopóki nie otrzymasz potwierdzenia wydania rowiniety.',
    warning_txt_4: 'UNTRR nie ponosi odpowiedzialności za nieprzestrzeganie powyższych warunków!',
    choose_card: 'Wybierz jedną z zapisanych kart',
    new_card: 'Nowa karta',
    add_card_for_next_transactions: ' Dodaj kartę do mojego konta, w celu przyszłych zakupów',

    free: 'Bezpłatnie',
    btn_logout: 'Log out',
    info: 'Info',

    frequent_questions_heading: 'Często zadawane pytania i odpowiedzi na nie  ',
    see_all_frequent_questions: 'Zobacz wszystkie pytania i odpowiedzi',

    step: 'Krok {n}',
    choose_passings_number: 'Wybierz liczbę przejazdów',
    vehicles: 'Samochody osobowe',

    juridical_person: 'Osoba prawna',
    individual_person: 'Osoba fizyczna',
    auto_query_company_data: 'Automatycznie przejmujemy dane Twojej firmy',
    verified_company_data: 'Sprawdzone dane o firmie!',
    unverified_company_data: 'Niesprawdzone dane o firmie',
    check_vignette_valability: 'Sprawdź ważność rowiniety',
    resources: 'Zasoby',
    i_want_vignette: 'Chcę rowinietę ',
    i_want_toll: 'Chcę opłatę za most w Fetești',
    vehicle_type: 'Rodzaj pojazdu',
    period: 'Okres',
    summary: 'Streszczenie',
    billing: 'Zafakturowanie',
    payment: 'Płatność',
    you_have_multiple_usernames: 'Macie <b>{count}</b> wiele nazw użytkowników pod tym adresem e-mailowym.',
    choose_login_account: 'Wybierzcie konto, którym chcecie się zalogować',

    //benefits page
    bp_company_advantages: 'Korzyści dla firm',
    bp_one_account_multiple_advantages: 'Jedno konto, więcej korzyści',
    bp_contact_us_for_personalized_solution: 'Skontaktujcie się z nami, aby uzyskać customizowane rozwiązanie',
    bp_online_emission: 'Wystawiwanie online 24/7',
    bp_online_assistance: ' Macie wsparcie online i możecie kupić rowinietę lub opłatę za most Fetești 24/7',
    bp_import_your_cars: 'Zaimportujcie całą flotę pojazdów',
    bp_import_you_cars_through_excel: 'Zaimportujcie do nas  całą flotę pojazdów firmy na podstawie pliku excel.',
    bp_multiple_profiles: 'Więcej profili',
    bp_multiple_profiles_for_same_email: 'Możecie utworzyć wiele profili dla wszystkich użytkowników firmy pod tym samym adresem e-mailowym.',
    bp_vignettes_status: 'Status rowiniet',
    bp_verify_vignette_status: 'Na stronie zawsze można sprawdzić status wydanych roviniet.',
    bp_orders_history: 'Historia zamówień ',
    bp_orders_history_description: 'Na koncie znajdujecie wszystkie złożone zamówienia i faktury.',
    bp_multiple_orders: 'Wielokrotne zamowienia',
    bp_multiple_orders_description: 'Do koszyka możecie dodać wiele rowiniet oraz złożyć wielokrotne zamówienia.',
    bp_email_sms_confirmation: 'Potwierdzenie e-mailem oraz SMS-em ',
    bp_email_sms_confirmation_description: 'Otrzymujecie potwierdzenie wystawienia rowiniety e-mailem i SMS-em.',
    bp_expiry_alerts: 'Alerty przypominające o wygaśnięciu rowiniety',
    bp_expiry_alerts_description: 'W przypadku rowiniet na 30 dni i powyżej 30 dni ostrzegamy e-mailem przed upływem terminu ważności.',
    bp_need_help: 'Czy potrzebna jest pomoc?',
    bp_call_operators:  'Zadzwońcie do jednego z naszych operatorów, aby uzyskać pomoc w wydawaniu rowiniet. Usługa jest dostępna od poniedziałku do piątku (z wyjątkiem dni ustawowo wolnych od pracy) w godzinach od 8:00 do 17:00.',
    bp_offices: 'Lista biur przedstawicielskich',
    bp_have_cars: 'Czy posiadacie flotę pojazdów?',
    bp_contact_us_for_personalized_solution_for_your_bussiness: 'Skontaktujcie się z nami, abyśmy mogli zaoferować customizowane rozwiązanie dla Waszego biznesu.',
    bp_contact_us_now: 'Skontaktujcie się z nami teraz',


    //contact
    contact_viggnete_emission: 'Wystawianie rowiniet',
    contact_agencies: 'Agencje',
    contact_see_all_agencies: 'Zobacz wszystkie agencje regionalne',
    contact_see_all_agencies_continuation: 'gdzie można dostać rowiniety.',

    //distribution
    distribution_header: 'LISTA MIEJSC WYKONYWANIA DZIAŁALNOŚCI NALEŻĄCYCH DO UNTRR UPOWAŻNIONYCH DO POBIERANIA OPŁAT ZA KORZYSTANIE Z SIECI DROGOWEJ W RUMUNII (ROWINIETA)',
    distribution_nr_crt: 'L.p.',
    distribution_work_point: 'Miesce wykonywania działalności',
    distribution_terminals_and_portals: 'TERMINALE I PORTALE WEB',
    distribution_name: 'Nazwa',
    distribution_terminals: 'Terminale ZEBRAPAY',
    distribution_location_terminal_details: 'Szczegóły o lokalizacjach terminali ZEBRAPAY',
    distribution_untrr_portal: 'PORTAL UNTRR',


    //footer
    footer_copyright: 'Wszystkie prawa zastrzeżone  2010 - 2020 @ Krajowy Związek Przewoźników Drogowych w Rumunii.',


    //homepage
    homepage_authorized_distributor: 'Autoryzowany dystrybutor C.N.A.I.R',
    homepage_buy_tpf_erv: 'Kup rowinietę lub opłatę mostową  Fetești',
    homepage_ready_for_road: 'Zaraz gotowy do jazdy',
    homepage_order: 'Zamów',
    homepage_payment: 'Zapłać',
    homepage_drive: 'Jedź',
    homepage_your_advantages: 'Twoje korzyści',
    homepage_vignette_availability: 'Sprawdzasz ważność rowiniety',
    homepage_vignette_availability_description_1: 'Nie wiesz, czy masz ważną rowinietę? Uniknij mandatu.',
    homepage_vignette_availability_description_2: 'Sprawdź tutaj ważność',
    homepage_save_data: 'Zapisz dane',
    homepage_save_data_description: 'Zakładasz konto, zapisujesz dane pojazdu i kupujesz w jednym miejscu rowinietę i opłatę mostową Fetești.',
    homepage_sms_email_delivery: 'Dostawa e-mailem i SMS-em',
    homepage_sms_email_delivery_description: 'Dostawa e-mailem i SMS-em',
    homepage_card_or_op: 'Płacisz kartą lub poleceniem płatności',
    homepage_card_or_op_description: 'Szybki i bezpieczny zakup kartą bankową lub przelewem.',
    homepage_notify_expiry: 'Powiadomienie o wygaśnięciu',
    homepage_notify_expiry_description: 'W przypadku rowiniet na okres dłuższy niż 30 dni ostrzegamy przed ich wygaśnięciem.',
    homepage_professional_services: 'Profesjonalne usługi',
    homepage_professional_services_description: 'Od profesjonalistów transportowych dla wszystkich użytkowników sieci drogowej w Rumunii.',
    homepage_online_assistance: 'Dodatkowo, masz wsparcie online i korzystasz z rozwiązania dostosowanego do potrzeb Twojej firmy.',
    homepage_discover_all_benefits: 'Odkryj wszystkie korzyści',
    homepage_distribution_points: 'Punkty dystrybucji',
    homepage_authorized_distributor_2: 'UNTRR este distribuitor autorizat de C.N.A.I.R. pentru emitere de roviniete electronice cu prezență în mediul online şi cu puncte teritoriale.',
    homepage_distribution_points_description: 'Zobacz listę punktów dystrybucji',
    homepage_frequent_questions: 'Często zadawane pytania i odpowiedzi na nie',
    homepage_frequent_questions_description: 'Zobacz wszystkie pytania i odpowiedzi',

    //info
    info_download_file: 'Pobierz plik',

    //reset
    reset_cart: 'Koszyk został ponownie ustawiony.',

    sms_notice: '<strong>Usługa taryfowana powiadomień za pomocą SMS</strong><br/><br/> Usługa krótkich wiadomości (SMS) umożliwia powiadamianie klientów www.taxa-pod-fetesti.ro w celu potwierdzenia wydania opłaty za most, lub odpowiednio powiadamianie klientów o wygaśnięciu ważności opłaty za most. Usługa jest opcjonalna, według wyboru klienta i dotyczy tylko zamówień opłacanych online za pośrednictwem procesora płatności (PayU).<br/><br/> Za poprawność danych i informacji w wiadomości SMS o wydaniu i/lub wygaśnięciu opłaty za most, numer rejestracyjny, seria VIN i numer telefonu komórkowego, wprowadzone na platformie www.taxa-pod-fetesti.ro, ponosi wyłączną odpowiedzialność użytkownik.<br/><br/>  Powiadomienie SMS odbywa się za pośrednictwem NETOPIA Payments.<br/><br/>    System powiadomień SMS wysyła powiadomienia do klientów, którzy zdecydują się na tę usługę.<br/><br/> Odbieranie SMS potwierdzających/wygasających może mieć wpływ na działanie i zasięg sieci telekomunikacyjnych, działanie używanych urządzeń itp.<br/><br/> W przypadku reklamacj,i prosimy o skorzystanie ze strony kontaktowej serwisu www.taxa-pod-fetesti.ro.'

};
